import { api } from './api';
import type {
  WorkerStatsEntry,
  AccidentStatsEntry,
} from '../types/site-stats';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  error: null | { code: string; message: string };
}

// Worker Stats
export async function getWorkerStats(orgId: string, siteId: string, periodType?: string) {
  const params = periodType ? { periodType } : {};
  const { data } = await api.get<ApiResponse<WorkerStatsEntry[]>>(
    `/organizations/${orgId}/sites/${siteId}/worker-stats`,
    { params },
  );
  return data;
}

export async function upsertWorkerStats(orgId: string, siteId: string, dto: WorkerStatsEntry) {
  const { data } = await api.put<ApiResponse<WorkerStatsEntry>>(
    `/organizations/${orgId}/sites/${siteId}/worker-stats`,
    dto,
  );
  return data;
}

export async function deleteWorkerStats(orgId: string, siteId: string, statsId: string) {
  const { data } = await api.delete<ApiResponse<null>>(
    `/organizations/${orgId}/sites/${siteId}/worker-stats/${statsId}`,
  );
  return data;
}

// Accident Stats
export async function getAccidentStats(orgId: string, siteId: string, periodType?: string) {
  const params = periodType ? { periodType } : {};
  const { data } = await api.get<ApiResponse<AccidentStatsEntry[]>>(
    `/organizations/${orgId}/sites/${siteId}/accident-stats`,
    { params },
  );
  return data;
}

export async function upsertAccidentStats(orgId: string, siteId: string, dto: AccidentStatsEntry) {
  const { data } = await api.put<ApiResponse<AccidentStatsEntry>>(
    `/organizations/${orgId}/sites/${siteId}/accident-stats`,
    dto,
  );
  return data;
}

export async function deleteAccidentStats(orgId: string, siteId: string, statsId: string) {
  const { data } = await api.delete<ApiResponse<null>>(
    `/organizations/${orgId}/sites/${siteId}/accident-stats/${statsId}`,
  );
  return data;
}
